/** The affiliate programme runs on Rewardful. */
export const REWARDFUL = {
  signup: 'https://easy-peasy-ai.getrewardful.com/signup',
  login: 'https://easy-peasy-ai.getrewardful.com/login',
  terms: 'https://easy-peasy-ai.getrewardful.com/terms',
} as const;

/** Share of every payment a referred customer makes. */
export const COMMISSION = 0.3;

/** A referral counts if the visitor buys within this many days of the click. */
export const COOKIE_DAYS = 60;

/** A plan in the earnings calculator, priced from the database at build time. */
export type CalculatorPlan = {
  name: string;
  /** Monthly price in US dollars. */
  monthly: number;
  /** "from" when the plan has several sizes (Teams). */
  from?: boolean;
  /** Where the slider starts and how far it goes. */
  start: number;
  max: number;
};

export const formatUsd = (value: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: value % 1 === 0 ? 0 : 2,
  }).format(value);
